import {Button} from 'antd';
import styled from 'styled-components';

const LinkButton = styled(Button).attrs({type: 'link'})`
  padding: 0;
  font-size: inherit;
`;

export default LinkButton;
